<div class="">

    <div class="text-right">
        Дней до оплаты сервиса:
        <b [ngClass]="{'notExpired': daysToExpiration >= 5,
        'expireSoon': daysToExpiration < 5,
        'expireWarning': daysToExpiration < 3}">{{ daysToExpiration }}</b>

    </div>

    <div class="w-full">
        <router-outlet></router-outlet>
    </div>

</div>